const initProductForms = () => {
  document.querySelectorAll("product-form").forEach(initSingleForm);
};

const initRecommededProductForms = () => {
  document.querySelectorAll("product-recommendations product-form").forEach(initSingleForm);
};

const initUpsellProductForms = () => {
  document.querySelectorAll(".remaining-variants-slider product-form").forEach(initSingleForm);
};
const initSingleForm = (formWrapper) => {
  const rows = formWrapper.querySelectorAll(".variant__picker--item.picker__item--value");

  //setDefaultFirstQty(rows);

  rows.forEach(row => setupRow(row, formWrapper));
};

const setDefaultFirstQty = (rows) => {
  const anySet = [...rows].some(row => {
    const qtyInput = row.querySelector(".quantity__input");
    return (parseInt(qtyInput?.value) || 0) > 0;
  });

  if (!anySet && rows.length > 0) {
    const firstInput = rows[0].querySelector(".quantity__input");
    if (firstInput) firstInput.value = 1;
  }
};

const setupRow = (row, formWrapper) => {
  const minusBtn = row.querySelector(".btn__minus");
  const plusBtn = row.querySelector(".btn__plus");
  const qtyInput = row.querySelector(".quantity__input");

  const priceEl = row.querySelector(".money");
  const price = priceEl
    ? parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ""))
    : 0;

  qtyInput.dataset.price = price;

  // 🔁 Centralized state handler
  const updateQtyState = () => {
    const value = parseInt(qtyInput.value) || 0;
    const max = qtyInput.max ? parseInt(qtyInput.max) : null;

    if (max !== null) {
      const reachedMax = value >= max;

      // Disable / enable plus button
      plusBtn.classList.toggle("disabled", reachedMax);

      // Make input readonly at max
      qtyInput.readOnly = reachedMax;
    }
  };

  // ➕ Plus button
  plusBtn?.addEventListener("click", () => {
    const currentValue = parseInt(qtyInput.value) || 0;
    const max = qtyInput.max ? parseInt(qtyInput.max) : null;

    if (max !== null && currentValue >= max) return;

    qtyInput.value = currentValue + 1;
    qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
  });

  // ➖ Minus button
  minusBtn?.addEventListener("click", () => {
    let newVal = (parseInt(qtyInput.value) || 0) - 1;
    if (newVal < 0) newVal = 0;

    qtyInput.readOnly = false; // allow editing again
    qtyInput.value = newVal;
    qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
  });

  // ⌨️ Input change (manual typing / paste / buttons)
  qtyInput.addEventListener("input", () => {
    let value = parseInt(qtyInput.value) || 0;
    const max = qtyInput.max ? parseInt(qtyInput.max) : null;

    // 🔒 HARD CAP — auto-fix values above max
    if (max !== null && value > max) {
      value = max;
      qtyInput.value = max;
    }

    updateQtyState();
    updateCardTotal(formWrapper);
  });

  // Initial sync
  qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
};





const updateCardTotal = (formWrapper) => {
  let cardTotal = 0;
  let allZero = true;

  formWrapper.querySelectorAll(".quantity__input").forEach(input => {
    const qty = parseInt(input.value) || 0;
    const price = parseFloat(input.dataset.price) || 0;

    if (qty > 0) allZero = false;
    cardTotal += qty * price;
  });

  const btn = formWrapper.querySelector(".product-form__submit");
  const btnLabel = btn?.querySelector("span");

  if (btnLabel) {
    btnLabel.textContent = cardTotal > 0
      ? `Add to cart – $${cardTotal.toFixed(2)}`
      : "Add to cart";
  }

  if (btn) btn.disabled = allZero;

  console.log("Card Total:", cardTotal, "| Disabled:", allZero);
};

document.addEventListener("DOMContentLoaded", initProductForms);

